import { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import MenuLeftBar from "./MenuLeftBar";
import Header from "./Header";
// import Dashboard from "../Pages/Deshboard/Dashboard";
import UserAnalytics from "../Pages/UserAnalytics/UserAnalytics";
import AddEditUseAnalytics from "../Pages/UserAnalytics/AddEditUseAnalytics";
import FamilyDetail from "../Pages/UserAnalytics/FamilyDetail";
import EditFamilyList from "../Pages/UserAnalytics/EditFamilyList";
import UserNotification from "../Pages/UserNotification/UserNotification";
import EditNotification from "../Pages/UserNotification/EditNotification";
import Relations from "../Pages/Relations/Relations";
import ResultNotification from "../Pages/ResultNotification/ResultNotification";
import EditResultNotification from "../Pages/ResultNotification/EditResultNotification";
import WidowService from "../Pages/WidowService/WidowService";
import EditWidowService from "../Pages/WidowService/EditWidowService";
import WidowDaughter from "../Pages/WidowDaughterService/WidowDaughter";
import EditWidowDaughter from '../Pages/WidowDaughterService/EditWidowDughter';
import ContingencyEducation from "../Pages/ContingencyEducation/ContingencyEducation";
import EditContingencyEducation from "../Pages/ContingencyEducation/EditContingencyEducation";
import HigherEducation from "../Pages/HigherEducationAssistance/HigherEducation";
import EditHigherEducation from "../Pages/HigherEducationAssistance/EditHigherEducation";
import HealthOriented from "../Pages/HealthOrientedAssistance/HealthOriented";
import EditHealthOriented from "../Pages/HealthOrientedAssistance/EditHealthOriented";
import SendMessage from "../Pages/SendMessage/SendMessage";
import Entertainment from "../Pages/Entertainment/Entertainment";
import Committee from "../Pages/Committee/Committee";
import Gallery from "../Pages/Gallery/Gallery";
import Villages from "../Pages/Villages/Villages";
import Taluka from '../Pages/Taluka/Taluka';
import District from '../Pages/District/District';
import Occupations from '../Pages/Occupations/Occupations';
import Education from '../Pages/Education/Education';
import AdminSettings from '../Pages/AdminSettings/AdminSettings';
import Logout from '../Pages/Auth/Logout';
import UserType from '../Pages/UserType/UserType';
import Funds from '../Pages/Funds/Funds';
import Honored from '../Pages/Honored/Honored';
import Year from '../Pages/Honored/Year';
import Donator from '../Pages/Funds/Donator';
import Award from '../Pages/Honored/Award';

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentTitle, setCurrentTitle] = useState('users-analytics');
    const location = useLocation();

    // Map routes to their display titles
    const routeTitles = {
        // '/dashboard': 'Dashboard',
        '/users-analytics': 'Users Analytics',
        '/users-analytics/add-user': 'Users Analytics',
        '/edit-family-list': 'Users Analytics',
        '/edit-family-list/family-details': 'Users Analytics',
        '/users-notification': 'User Notifications',
        '/users-notification/edit-notification': 'User Notifications',
        '/relations': 'Relations',
        '/result-notification': 'Result Notifications',
        '/result-notification/edit-result-notification': 'Result Notifications',
        '/widow-service': 'Widow Service',
        '/widow-service/edit-widow-service': 'Widow Service',
        '/widow-service/edit-widow-service': 'Widow Service',
        '/widow-daughter': 'Widow Daughter Service',
        '/widow-daughter/edit-widow-daughter-service': 'Widow Daughter Service',
        '/contingency-education': 'Contingency Education',
        '/contingency-education/edit-contingency-education': 'Contingency Education',
        '/higher-education-assistance': 'Higher Education Assistance',
        '/higher-education-assistance/edit-higher-education-assistance': 'Higher Education Assistance',
        '/health-oriented-assistance': 'Health Oriented Assistance',
        '/health-oriented-assistance/edit-health-oriented-assistance': 'Health Oriented Assistance',
        '/send-message': 'Send Message',
        '/entertainment': 'Entertainment',
        '/funds': 'Funds',
        '/donator': 'Donators',
        '/donator/:id': 'Donators',
        '/year': 'Year',
        '/award': 'Award',
        '/award/:id': 'Award',
        '/honored': 'Honored',
        '/honored/:id': 'Honored',
        '/committee': 'Committee',
        '/gallery': 'Gallery',
        '/villages': 'Villages',
        '/taluka': 'Taluka',
        '/district': 'District',
        '/occupations': 'Occupations',
        '/education': 'Education',
        '/admin/settings': 'Admin Settings',
        '/logout': 'Logout',
        '/userType': 'User Type',
    };

    useEffect(() => {
        const path = location.pathname;
        // remove dynamic id and match route
        const baseRoute = path.split('/').slice(0, -1).join('/');
        
        if (location.state?.yearData?.year) {
            setCurrentTitle(location.state.yearData.year);
        } else if (path.startsWith('/donator/') && location.state?.donatorData?.gujarati_name) {
            setCurrentTitle(location.state.donatorData.gujarati_name);
        } else if (path.startsWith('/honored/') && location.state?.honoredData?.gujarati_name) {
            setCurrentTitle(location.state.honoredData.gujarati_name);
        } else {
            setCurrentTitle(routeTitles[path] || routeTitles[baseRoute] || 'Users Analytics');
        }
    }, [location]);

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
    };

    const closeSidebar = () => {
        setIsOpen(false);
    };

    return (
        <div>

            <div className="flex bg-white">
                {/* Mobile Sidebar */}
                <div
                className={`xl:hidden fixed inset-y-0 left-0 z-50 w-[300px] bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
                    isOpen ? 'translate-x-0' : '-translate-x-full'
                }`}
            >
                <MenuLeftBar closeSidebar={closeSidebar} />
            </div>

            {/* Overlay */}
            {isOpen && (
                <div
                    className="xl:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
                    onClick={closeSidebar}
                />
            )}

            {/* Desktop Sidebar */}
            <div className="hidden xl:block w-[300px] h-[100vh] border-r shrink-0 sticky top-0">
                <MenuLeftBar />
            </div>

            {/* Main Content Area */}
            <div className="w-full">
                <Header title={currentTitle} toggleSidebar={toggleSidebar} />
                <div>
                    <Routes>
                        {/* <Route path="" element={<Navigate to="dashboard" />} /> */}
                        {/* <Route path={`*`} index element={<Dashboard />} />
                        <Route path="dashboard" index element={<Dashboard />} /> */}
                        <Route path="users-analytics" element={<UserAnalytics />} />
                        <Route path="users-analytics/add-user/:id?" element={<AddEditUseAnalytics />} />
                        <Route path="edit-family-list/:id?" element={<EditFamilyList />} />
                        <Route path="edit-family-list/family-details/:id/:memberId?" element={<FamilyDetail />} />
                        <Route path="users-notification" element={<UserNotification />} />
                        <Route path="users-notification/edit-notification/:id?" element={<EditNotification />} />
                        <Route path="relations" element={<Relations />} />
                        <Route path="result-notification" element={<ResultNotification />} />
                        <Route path="result-notification/edit-result-notification/:id?" element={<EditResultNotification />} />
                        <Route path="widow-service" element={<WidowService />} />
                        <Route path="widow-service/edit-widow-service" element={<EditWidowService />} />
                        <Route path="widow-daughter" element={<WidowDaughter />} />
                        <Route path="widow-daughter/edit-widow-daughter-service" element={<EditWidowDaughter />} />
                        <Route path="contingency-education" element={<ContingencyEducation />} />
                        <Route path="contingency-education/edit-contingency-education" element={<EditContingencyEducation />} />
                        <Route path="higher-education-assistance" element={<HigherEducation />} />
                        <Route path="higher-education-assistance/edit-higher-education-assistance" element={<EditHigherEducation />} />
                        <Route path="health-oriented-assistance" element={<HealthOriented />} />
                        <Route path="health-oriented-assistance/edit-health-oriented-assistance" element={<EditHealthOriented />} />
                        <Route path="send-message" element={<SendMessage />} />
                        <Route path="entertainment" element={<Entertainment />} />
                        <Route path="funds" element={<Funds />} />
                        <Route path="donator" element={<Donator />} />
                        <Route path="donator/:id" element={<Donator />} />
                        <Route path="year" element={<Year />} />
                        <Route path="award" element={<Award />} />
                        <Route path="award/:id" element={<Award />} />
                        <Route path="honored" element={<Honored />} />
                        <Route path="honored/:id" element={<Honored />} />
                        <Route path="committee" element={<Committee />} />
                        <Route path="gallery" element={<Gallery />} />
                        <Route path="userType" element={<UserType />} />
                        <Route path="villages" element={<Villages />} />
                        <Route path="taluka" element={<Taluka />} />
                        <Route path="district" element={<District />} />
                        <Route path="occupations" element={<Occupations />} />
                        <Route path="education" element={<Education />} />
                        <Route path="admin/settings" element={<AdminSettings />} />
                        <Route path="logout" element={<Logout />} />
                    </Routes>
                </div>
            </div>
        </div>
        </div>

    );
};

export default Sidebar;